import { createRequestFields, createInitialFormData } from "src/models/common/form_modal";
import { Price } from "./price.model";
import { Pagination } from "src/models/common/table_main";

export interface PriceRequest {
    item: string;
    price: string;
    createdBy?: string;
    createdDate?: string;
  }
  
  export interface SubmitRequest {
    importPrice: Array<PriceRequest>;
    userId: string;
  }
  
  export interface Pricetate {
    data: Price[] | null;
    pagination: Pagination | null;
    loading: boolean;
    error: boolean;
    errorMessage: string;
  }
  
  export const priceInitialState: Pricetate = {
    data: null,
    pagination:null,
    loading: false,
    error: false,
    errorMessage: null,   
  };
  
  // Ini untuk Form Add / Update 
  export const priceRequest = createRequestFields<Price>([
    { label: 'Item', name: 'item' , dataType:'string'},
    { label: 'Price', name: 'price' , dataType:'string'},
  ]);
  
  export const initialPriceFormData = createInitialFormData<Price>(priceRequest);
  